import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/global.css'

Vue.config.productionTip = false

// 初始化主题
const savedTheme = localStorage.getItem('theme') || 'dark'
document.body.setAttribute('data-theme', savedTheme)
if (savedTheme === 'dark') {
  document.documentElement.classList.add('dark')
} else {
  document.documentElement.classList.remove('dark')
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

